import { createFileRoute } from '@tanstack/react-router';
import { MenuManagementPage } from '@/features/tenant-admin/pages';

export const Route = createFileRoute('/tenant-admin/menu-management')({
  component: MenuManagementPage,
});
